import styled from '@emotion/styled';

export const PhoneNumberContainer = styled.div`
	display: flex;
	flex-direction: row;
	gap: 1rem;

	.enumSelect {
		min-width: 13rem;

		> .custom-disabled-field {
			justify-content: center;
		}
	}

	body[dir='rtl'] & {
		direction: ltr;

		input {
			text-align: right;
		}
	}
`;

export const InputContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;

	.string-input-error-message-container {
		margin-left: -14rem;

		body[dir='rtl'] & {
			direction: rtl;
		}
	}

	.string-input-success-message-container {
		margin-left: -14rem;

		body[dir='rtl'] & {
			direction: rtl;
		}
	}
`;

export const OptionContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 1rem;
	padding: 0 0.5rem;

	&.selected {
		gap: 0.5rem;
	}
`;
